import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import * as S from './BusinessDesignStyle';
import LeftTabContent from './LeftTabContent';
import RightTabList from './RightTabList';

const BusinessDesign = ({ isMobile }) => {
	const [indexClicked, setIndexClicked] = useState(0);
	const businessDesignData = useSelector((state) => state.resource.businessDesignData || {});
	const { content = [] } = businessDesignData;

	return (
		<S.Wrapper id='BusinessDesign'>
			<S.BusinessDesignContainer>
				<LeftTabContent
					data={content[indexClicked]}
					isMobile={isMobile}
				/>
				<RightTabList
					businessTabContent={businessDesignData}
					setIndexClicked={setIndexClicked}
					indexClicked={indexClicked}
					isMobile={isMobile}
				/>
			</S.BusinessDesignContainer>
		</S.Wrapper>
	);
};

export default BusinessDesign;
